import MailChimpAudiencePicker from "../MailChimpAudiencePicker";
import type { RuleItemEditorBaseProps } from "../ruleItemEditorTypes";

type Props = RuleItemEditorBaseProps & { data: any };

export default function RuleItemEditorMailchimp({ ruleItem, updateRuleItem, data }: Props) {
  return (
    <div>
      <MailChimpAudiencePicker
        onChange={(audienceList) => {
          updateRuleItem({
            ...ruleItem,
            data: {
              ...ruleItem.data,
              listId: audienceList.value,
              listName: audienceList.label,
            },
          });
        }}
        defaultName={data.listName}
      />
    </div>
  );
}
